//
import type { IPolicyPolicyDataBeneficiary } from '@/shared/api/models.bff';

export interface IBeneficiary {
  name: string;
  firstName: string;
  lastName: string;
  personCode: string;
  relation: string;
  ssn: string;
  effectiveDate: string;
}

export const mapBeneficiaryResponse = ({
  BenePersonCode,
  BeneEffectiveDate,
  BeneRelation,
  BeneSSN,
  BeneName,
  BeneFirstName,
  BeneLastName,
}: IPolicyPolicyDataBeneficiary): IBeneficiary => {
  const mappedBeneficiary = {
    name: BeneName,
    firstName: BeneFirstName,
    lastName: BeneLastName,
    personCode: BenePersonCode,
    relation: BeneRelation,
    ssn: BeneSSN,
    effectiveDate: BeneEffectiveDate,
  };
  return mappedBeneficiary;
};
